module.exports = __webpack_public_path__ + "media/images/countdown-9517a394feb8b9d5544ce21063f4bb90.png";